import styled from "styled-components";
import INFO_SRC from "../../Icons/Info.svg";

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 6000;
`;

export const ModalBox = styled.div`
  width: 560px;
  background: #FCFCFC;
  border-radius: 4px;
  padding: 24px 32px 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-family: "Noto Sans";
  font-weight: 400;
  color: #36424A;
`;

export const CloseButton = styled.button`
  width: 32px;
  height: 32px;
  background: transparent;
  border-radius: 50%;
  border: none;
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 18px;
    height: 18px;
    object-fit: contain;
    display: block;
  }
`;

export const Title = styled.div`
  color: #36424A;
  font-size: 16px;
  font-family: "Noto Sans";
  font-weight: 400;
  line-height: 22px;
`;

/**
 * The "…and these other codes arrived at the same time" line.
 *
 * Deliberately quieter than the `Title` it sits under: it is context for support, not a second
 * thing to read. The failure the user is being told about is the one above it.
 */
export const Aside = styled.div`
  color: #6B7780;
  font-size: 13px;
  font-family: "Noto Sans";
  font-weight: 400;
  line-height: 18px;
  margin-top: -12px;
`;

export const ButtonsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 24px;
`;

export const OkButton = styled.button`
  background: #004D9E;
  color: white;
  font-size: 15px;
  font-family: "Noto Sans";
  font-weight: 500;
  border: none;
  padding: 12px 16px;
  border-radius: 30px;
  min-width: 80px;
  cursor: pointer;
`;

export const CancelButton = styled.button`
  background: transparent;
  border: 1px solid #C4C7C8;
  border-radius: 30px;
  padding: 12px 16px;

  color: #36424A;
  font-size: 15px;
  font-weight: 500;
  font-family: "Noto Sans";

  cursor: pointer;
`;